import events from "@/content/events.json";
import Reveal from "@/components/home/Reveal";
import EventCard from "@/components/home/EventCard";
import { useRegisterModal } from "@/components/home/RegisterModalProvider";

export const SeasonalCampaigns = () => {
  const { openModal } = useRegisterModal();
  return (
    <section id="campanas" className="mt-section bg-brand-cream relative overflow-hidden scroll-mt-20" data-testid="campaigns-section">
      <div className="absolute -bottom-32 -left-32 w-[420px] h-[420px] rounded-full bg-brand-orange/10 blur-3xl pointer-events-none" />
      <div className="mt-container relative">
        <Reveal className="max-w-3xl">
          <p className="text-brand-orange font-semibold text-sm uppercase tracking-wider">Eventos gastronómicos 2026</p>
          <h2 className="mt-2 text-3xl sm:text-4xl lg:text-5xl leading-tight">¿Vas a participar en una Restaurant Week? Te damos alta express.</h2>
          <p className="mt-4 text-base md:text-lg text-gray-600">Si tu restaurante está inscrito en un evento gastronómico regional, activamos tu menú en MenuThere con alta express, literalmente en minutos, para que no pierdas ni un pedido.</p>
        </Reveal>
        <div className="mt-12 grid lg:grid-cols-2 gap-6 lg:gap-8">
          {events.items.map((ev, i) => (
            <Reveal key={ev.id} delay={i * 120}>
              <EventCard {...ev} index={i} onCta={() => openModal(ev.title)} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SeasonalCampaigns;
